<footer class="footer">
  <div class="footer__row">
    <img src="/assets/img/logo.png" class="footer__logo" alt="Starterem po nagrody">
    <ul class="footer__menu">
      <li><a href="https://starteremponagrody.pl/docs/starterem_po_nagrody_regulamin.pdf" target="_blank">Regulamin programu</a></li>
      <li><a href="https://starteremponagrody.pl/docs/starterem_po_nagrody_regulamin_PP.pdf" target="_blank">Regulamin dla pracownika poczty polskiej</a></li>
      <li><a href="https://starteremponagrody.pl/docs/polityka-prywatnosci.html" target="_blank">Polityka prywatności</a></li>
      <li><a routerLink="/secured/contact">Kontakt</a></li>
    </ul>
    <ul class="footer__social">
      <li>
        <a href="https://twitter.com/TMobilePolska" target="_blank">
          <img src="/assets/img/icon_twitter.png" alt="">
        </a>
      </li>
      <li>
        <a href="https://www.youtube.com/user/TMobilePL" target="_blank">
          <img src="/assets/img/icon_youtube.png" alt="">
        </a>
      </li>
      <li>
        <a href="https://www.facebook.com/tmobilepl" target="_blank">
          <img src="/assets/img/icon_facebook.png" alt="">
        </a>
      </li>
    </ul>
  </div>
  <p class="footer__copyright">© 2024 T-Mobile Polska S.A. Wszystkie prawa zastrzeżone.</p>
</footer>
